<div class="alert alert-dismissible alert-{{type}}" *ngIf="msg && msg !== ' '" [@alertState]="alertState">
  <button type="button" class="close" data-dismiss="alert" (click)="msg = null" *ngIf="dismissible">×</button>
  <h4 class="alert-heading" *ngIf="title">{{title}}</h4>
  <p class="mb-0" [innerHTML]="msg"></p>
</div>